import LogoKlasika from "./smklasik.png";
import LogoGlasbaM from "./smglasbamladih.png";
import LogoKreativa from "./smkreativ.png";
import LogoGostuje from "./smagost.png";

export const cikliPodatki = [
    {
        slug: "slovenska-mlada-klasika",
        ime: "Slovenska mlada klasika",
        opis: "koncerti in recitali klasične glasbe za komorne zasedbe, zbore, solistične glasbenike…",
        logo: LogoKlasika,
        podnaslov: "dasfsdfasdfasd",
        vsebina: "dasfsdfasdfasd",
    },
    {
        slug: "glasba-mladih",
        ime: "Iniciativa glasba mladih",
        opis: "projekti na katerih so v prvi vrsti izvajana dela mladih slovenskih skladateljev",
        logo: LogoGlasbaM,
        podnaslov: "dasfsdfasdfasd",
        vsebina: "dasfsdfasdfasd",
    },
    {
        slug: "slovenska-mlada-kreativa",
        ime: "Slovenska mlada kreativa",
        opis: "cikel koncertov samoiniciativnih projektov, ki jih društvo organizatorsko in finančno podpira",
        logo: LogoKreativa,
        podnaslov: "dasfsdfasdfasd",
        vsebina: "dasfsdfasdfasd",
    },
    {
        slug: "sma-gostuje",
        ime: "SMA gostuje",
        opis: "koncerti gostujočih mladih tujih glasbenikov ali skupin, ki delujejo izven Slovenije",
        logo: LogoGostuje,
        podnaslov: "dasfsdfasdfasd",
        vsebina: "dasfsdfasdfasd",
    },
];
